module.exports = "<footer class=\"app-footer fixed-bottom pt-3 pb-3 navbar-fixed-bottom\">\n  <span style=\"color:red;font-weight:bold\" *ngIf=\"msgError\">{{ msgError }}</span>\n  <span style=\"color:green;font-weight:bold\" *ngIf=\"msgSuccess\">{{ msgSuccess }}</span>\n  <span class=\"ml-auto\"><strong>Cryosoft</strong> &copy; {{date| date:'yyyy'}} AirLiquide.</span>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// /home/dfm/cryosoft/ui/src/app/components/app-footer/app-footer.component.html
// module id = ../../../../../src/app/components/app-footer/app-footer.component.html
// module chunks = main